module.exports = __webpack_public_path__ + "static/media/no-contractors.f22efd1f.svg";